module.exports = __webpack_public_path__ + "img/martine-alt.c35e1349.png";